const styles = theme => ({
  tableContainer: {
    marginTop: 16,
    marginBottom: 16,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  tableHeaderRow: {
    backgroundColor: '#0b3d64',
    color: '#fff',
  },
  tableCell: {
    padding: '12px',
    textAlign: 'left',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tableHeaderCell: {
    padding: '12px',
    textAlign: 'left',
    backgroundColor: '#0b3d64 !important',
    color: '#fff !important',
    fontWeight: 'bold',
    borderBottom: '1px solid #062b47',
  },
  dialogHeading: {
    backgroundColor: '#263238',
    boxSizing: 'border-box',
    color: '#fff',
    display: 'block',
    margin: '-24px -32px 20px',
    padding: '16px 32px',
  },
  tableRow: {
    '&:nth-child(even)': {
      backgroundColor: theme.palette.background.default,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  modalContent: {
  },
  modalTitle: {
    marginTop: 0,
    marginBottom: 16,
  },
  checkName: {
    fontWeight: 'bold',
  },
  statusPassed: {
    color: '#4caf50',
    fontWeight: 'bold',
  },
  statusFailed: {
    color: '#f44336',
    fontWeight: 'bold',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
  },
  closeButton: {
    padding: '8px 16px',
  },
});

export default styles;
